import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import msg from 'msg';

import ProductLabel from 'apps/products/models/ProductLabel';
import OfferType from 'apps/products/models/OfferType';

const FopCornerLabel = ({ product, user }) => {
  if (!product || !product.labels || !product.labels.length) {
    return null;
  }

  const { labels, offer } = product;

  if (labels.includes(ProductLabel.OOS)) {
    return (
      <span className="fop-mark-oos fop-image-corner">Out of Stock</span>
    );
  }

  if (labels.includes(ProductLabel.ON_OFFER) &&
    offer &&
    (
      // If offer is not SmartPass, we're good
      offer.type !== OfferType.SMART_PASS_ELIGIBLE ||
      // If offer is SmartPass,  show "Offer" label if user is eligible.
      get(user, 'eligibilityDetails.smartPassEligibility') === 'ELIGIBLE'
    )) {
    const isEdlp = labels.includes(ProductLabel.EDLP);

    if (isEdlp) {
      return (
        <span className="fop-mark-edlp fop-image-corner">{msg.fop.label.edlp}</span>
      );
    }

    return (
      <span className="fop-mark-offer fop-image-corner">{msg.fop.label.offer}</span>
    );
  }

  if (labels.includes(ProductLabel.NEW)) {
    return (
      <span className="fop-mark-new fop-image-corner">New</span>
    );
  }

  return null;
};

FopCornerLabel.propTypes = {
  product: PropTypes.shape({
    labels: PropTypes.arrayOf(PropTypes.oneOf(Object.values(ProductLabel))),
    offer: PropTypes.shape({
      type: PropTypes.string.isRequired,
    }),
  }),
  user: PropTypes.object,
};

export default FopCornerLabel;
